import React from 'react';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Dialog from '@material-ui/core/Dialog';
import { observer } from 'mobx-react';
import Picker from 'emoji-picker-react';
import { copyToClipboard } from 'utils/copyToClipboard';
import { getErrorsText, Severity, usePushNotifications } from 'services/NotificationService';

interface Props {
  open: boolean;
  handleToggle: React.Dispatch<React.SetStateAction<boolean>>;
}

export const EmojiSelectDialog: React.FC<Props> = observer(({ open, handleToggle }: Props) => {
  const notify = usePushNotifications();

  const handleSelect = (emoji: string) => {
    handleToggle(false);
    copyToClipboard(emoji)
      .then(() => {
        notify({
          title: 'Success',
          message: `${emoji} Copying to clipboard was successful`,
          severity: Severity.SUCCESS
        });
      })
      .catch((error) => {
        notify({
          title: 'Error',
          message: getErrorsText(error),
          severity: Severity.ERROR
        });
      });
  };
  return (
    <Dialog maxWidth="md" open={open} onClose={() => handleToggle(false)}>
      <DialogTitle>Select Emoji</DialogTitle>
      <DialogContent dividers>
        <div>
          <Picker
            onEmojiClick={(_, emojiObject) => {
              handleSelect(emojiObject.emoji);
            }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
});
